import chip1SVG from '../images/chips/svg/chip1.svg'
import chip5SVG from '../images/chips/svg/chip5.svg'
import chip10SVG from '../images/chips/svg/chip10.svg'
import chip25SVG from '../images/chips/svg/chip25.svg'
import chip50SVG from '../images/chips/svg/chip50.svg'
import chip100SVG from '../images/chips/svg/chip100.svg'

import chip1PNG from '../images/chips/png/chip1.png'
import chip5PNG from '../images/chips/png/chip5.png'
import chip10PNG from '../images/chips/png/chip10.png'
import chip25PNG from '../images/chips/png/chip25.png'
import chip50PNG from '../images/chips/png/chip50.png'
import chip100PNG from '../images/chips/png/chip100.png'


export const chipsImagesSVGLinks: Array<string> = [chip1SVG, chip5SVG, chip10SVG, chip25SVG, chip50SVG, chip100SVG]
export const chipsImagesPNGLinks: Array<string> = [chip1PNG, chip5PNG, chip10PNG, chip25PNG, chip50PNG, chip100PNG]